import { SortAscendingOutlined, SortDescendingOutlined } from '@ant-design/icons';
import { Flex } from 'antd';
import { memo } from 'react';
import type { CSSProperties } from 'react';
import DetailCellText from './DetailCellText';

interface SortHeaderProps {
  text: string;
  sortKey: string;
  direction: 'asc' | 'desc' | null;
  onSort: (key: string) => void;
}

const HEADER_STYLE: CSSProperties = { cursor: 'pointer', userSelect: 'none', flex: 1 };
const ICON_STYLE: CSSProperties = { color: '#1890ff' };

const SortHeader = memo(function SortHeader({ text, sortKey, direction, onSort }: SortHeaderProps) {
  return (
    <Flex align="center" gap={4} style={HEADER_STYLE} onClick={() => onSort(sortKey)}>
      <DetailCellText text={text} />
      {direction === 'asc' && <SortAscendingOutlined style={ICON_STYLE} />}
      {direction === 'desc' && <SortDescendingOutlined style={ICON_STYLE} />}
    </Flex>
  );
});

export default SortHeader;
